import * as yup from 'yup';
import texts from './phone.texts.json';

const NUMBERS_REGEX_VALIDATION = /^[0-9]*$/;
const PHONE_START_REGEX = /^05/;
const PHONE_REGEX = /^05[012345689]{1}[2-9]{1}[0-9]{6}$/;

type PhoneErrorMessage = yup.Message<{ regex: RegExp }>;

declare module 'yup' {
  interface StringSchema {
    phone(message?: PhoneErrorMessage): this;
  }
}

export function definePhoneValidator() {
  yup.addMethod(
    yup.string,
    'phone',
    function validate(
      message: PhoneErrorMessage = () => texts.phoneRegexError,
    ) {
      return this.required(texts.phoneEmptyError)
        .matches(NUMBERS_REGEX_VALIDATION, {
          message: () => texts.phoneOnlyNumbersError,
          name: 'phone-digits-only',
        })
        .matches(PHONE_START_REGEX, {
          message: () => texts.phoneStartRegexError,
          name: 'phone-initial-digits',
        })
        .matches(PHONE_REGEX, {
          message,
          name: 'phone',
        });
    },
  );
}
